import R from 'app/assets/R'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { FormCommon } from '../hook'
import { initValues } from '../type'
import { useModalHook } from './hook'
import { IPropsCreateAccount } from './type'

export const CreateAccount = (props: IPropsCreateAccount) => {
  const {
    form,
    visible,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
  } = useModalHook(props)

  return (
    <BaseModalManagement
      titleKeyI18n={R.strings.add_account}
      isLoading={isLoading}
      content={
        <BaseForm
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
          initialValues={initValues}
          form={form}
        >
          <FormCommon />
        </BaseForm>
      }
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.add_account}
      confirmKeyI18n={R.strings.add_account}
      handleSubmit={form.submit}
      visible={visible}
    />
  )
}
